<template>
    <div class="FormElements">
        <h5 class="FormElements__subheader">
            Check Boxes
        </h5>
        <div class="FormElements__row">
            <RPCheckbox v-model="check" />
            <RPCheckbox :value="true" />
            <RPCheckbox :value="false" />
            <RPCheckbox
                :value="false"
                deselected
            />
            <RPCheckbox
                :value="false"
                disabled
            />
        </div>
        <h5 class="FormElements__subheader">
            Input Fields
        </h5>
        <div class="FormElements__row">
            <RPTextInputUI
                v-model="input1"
                field-key="input1"
                name="Field"
                label="Field 1 - Standby"
                placeholder="Placeholder"
            />
            <RPTextInputUI
                v-model="input1"
                field-key="input1"
                name="Field"
                label="Field 1 - Standby"
                placeholder="Placeholder"
                status="loading"
            />
            <RPTextInputUI
                v-model="input1"
                label="Field 1 - Icon"
                placeholder="Placeholder"
            />
            <RPTextInputUI
                v-model="input1"
                label="Field 1 - Standby"
                label-tooltip="Additional Info"
                placeholder="Placeholder"
            />
            <RPTextInputUI
                v-model="input2"
                label="Field 1 - Standby (Disabled)"
                placeholder="Placeholder"
                :disabled="true"
            />
            <RPTextInputUI
                v-model="input3"
                label="Field 1 - Error"
                placeholder="Placeholder"
                status="error"
                status-message="Invalid Value"
            />
            <RPTextInputUI
                v-model="input4"
                label="Field 1 - Warning"
                placeholder="Placeholder"
                status="warning"
                status-message="Warning Value"
            />
            <RPTextInputUI
                v-model="input5"
                label="Field 1 - Success"
                placeholder="Placeholder"
                status="success"
            />
        </div>
        <h5 class="FormElements__subheader">
            Dropdown/Multiselect
        </h5>
        <div class="FormElements__row">
            <RPDropdown
                v-model="drop1"
                label="Single Select Dropdown"
                :options="options"
            />
            <RPDropdown
                v-model="drop1"
                label="Single Select Dropdown"
                :options="options"
                status="loading"
            />
            <RPDropdown
                v-model="multi2"
                label="Multi Select Dropdown"
                :options="options"
                label-tooltip="Tooltip"
            />
        </div>
        <h5 class="FormElements__subheader">
            Search Bar
        </h5>
        <div class="FormElements__row">
            <RPSearchBar v-model="searchInput" />
            <RPSearchBar
                v-model="searchInput"
                status="loading"
            />
        </div>
        <div
            class="FormElements__row"
            :style="{background: '#f4f4f4'}"
        >
            <RPSearchBar
                v-model="searchInput"
                background-color="grey"
            />
        </div>
        <h5 class="FormElements__subheader">
            Notification Emails
        </h5>
        <div class="FormElements__row">
            <!--<RPNotificationEmails-->
            <!--v-model="$v.newEmail.$model"-->
            <!--field-key="emailArray"-->
            <!--:validation="$v.newEmail"-->
            <!--:emails="emailArray"-->
            <!--@update-emails="updateEmails"-->
            <!--/>-->
            <!--<RPNotificationEmails-->
            <!--v-model="$v.newEmail1.$model"-->
            <!--field-key="emailArray"-->
            <!--:validation="$v.newEmail1"-->
            <!--:emails="emailArray"-->
            <!--status="loading"-->
            <!--@update-emails="updateEmails"-->
            <!--/>-->
            <!--<RPNotificationEmails-->
            <!--v-model="$v.newEmail2.$model"-->
            <!--field-key="emailArray"-->
            <!--:validation="$v.newEmail2"-->
            <!--:emails="emailArray"-->
            <!--status="saving"-->
            <!--/>-->
            <!--<RPNotificationEmails-->
            <!--v-model="$v.newEmail3.$model"-->
            <!--field-key="emailArray"-->
            <!--:validation="$v.newEmail3"-->
            <!--:emails="emailArray"-->
            <!--status="success"-->
            <!--/>-->
            <!--<RPNotificationEmails-->
            <!--v-model="$v.newEmail3.$model"-->
            <!--field-key="emailArray"-->
            <!--:validation="$v.newEmail3"-->
            <!--:emails="emailArray"-->
            <!--status="error"-->
            <!--server-error="One of the emails was invalid!"-->
            <!--/>-->
        </div>
        <h5 class="FormElements__subheader">
            Radio and Options Container
        </h5>
        <div class="FormElements__row">
            <RPRadioContainer
                v-model="radioSelected"
                label="Radio Container"
                :options="radioOptions"
            />
            <RPOptionsContainer
                v-model="optionSelected"
                :options="optionOptions"
                label="Options Container"
                label-tooltip="Tooltip"
            />
        </div>
    </div>
</template>

<script>
import merge from 'lodash/merge';
import {required, email} from 'vuelidate/lib/validators';
import RPCheckbox from 'components/Basic/FormElements/RPCheckbox.vue';
// import RPNotificationEmails from 'components/Basic/FormElements/NotificationEmails/RPNotificationEmails.vue';
import RPSearchBar from 'components/Basic/SearchBar/RPSearchBar.vue';
import RPTextInputUI from 'components/Basic/FormElements/TextInput/RPTextInputUI.vue';
import RPOptionsContainer from 'components/Basic/FormElements/RPOptionsContainer.vue';
import RPRadioContainer from 'components/Basic/FormElements/RPRadioContainer.vue';
import RPDropdown from 'components/Basic/FormElements/RPDropdown/RPDropdown.vue';
import has from 'lodash/has';
import {House1} from "@reviewpush/streamline-regular/lib/interface-essential/Home";

const serverError = function (fieldName) {
    return function (value, vm) {
        return !(has(vm, 'serverErrors') && has(vm.serverErrors, fieldName));
    };
};

export default {
    components: {
        RPTextInputUI,
        RPCheckbox,
        RPSearchBar,
        // RPNotificationEmails,
        RPRadioContainer,
        RPDropdown,
        RPOptionsContainer
    },
    data() {
        return {
            check: false,

            input1: '',

            input2: '',
            input3: '',
            input4: '',
            input5: '',

            drop1: '',
            drop2: '',
            multi2: [],
            multi3: [],
            multi4: [],

            searchInput: '',
            emailArray: [
                'test@gmail.com',
                'test1@gmail.com',
                'test2@gmail.com',
            ],
            newEmail: '',
            newEmail1: '',
            newEmail2: '',
            newEmail3: '',

            options: [
                {
                    label: "Option 1",
                    value: "opt1",
                    icon: House1,
                    description: 'Metric'
                },
                {
                    label: "Option 2",
                    value: "opt2",
                    icon: House1,
                    description: 'Metric'
                },
                {
                    label: "Option 3",
                    value: "opt3",
                    icon: House1,
                    description: 'Metric'
                },
                {
                    label: "Option 4",
                    value: "opt4",
                    icon: House1,
                    description: 'Metric'
                },        {
                    label: "Option 5",
                    value: "opt5",
                    icon: House1,
                    description: 'Metric'
                }
            ],
            radioSelected: true,
            radioOptions: [
                {
                    label: 'Enabled',
                    value: true,
                },
                {
                    label: 'Disabled',
                    value: false,
                },
            ],
            optionSelected: [],
            optionOptions: [
                {
                    label: 'Option 1',
                    value: 'opt1',
                },
                {
                    label: 'Option 2',
                    value: 'opt2',
                },
                {
                    label: 'Option 3',
                    value: 'opt3',
                },
            ],


            serverErrors: {
                input1: 'The name field is invalid server-side',
            },
            clientValidation: {
                input1: {
                    required,
                },
                newEmail: {
                    email,
                },
                newEmail1: {
                    email,
                },
                newEmail2: {
                    email,
                },
                newEmail3: {
                    email,
                }
            },
            serverValidation: {
                input1: {
                    serverError: serverError('nameField', false),
                },
            },
        };
    },
    computed: {
        validationRules() {
            return merge({}, this.serverValidation, this.clientValidation);
        },
        HomeIcon(){
            return House1;
        },
    },
    validations() {
        return this.validationRules;
    },
    methods: {
        updateEmails(emails){
            this.emailArray = emails;
            this.newEmail = '';
        }
    }
};
</script>

<style lang="scss">
    .FormElements {
        padding: 50px;
        &__subheader {
            margin-bottom: 20px;
        }
        &__row {
            display: flex;
            margin-bottom: 25px;
            padding: 2rem 1rem;
            & > * {
                margin-right: 25px;
            }
        }
        &__dropdown{
            width: 15rem;
        }
    }
</style>
